import React from 'react';
import CustomLink from '@gc-npm/components.custom-link';
import TextInfo from '@gc-npm/components.text';
import { useDispatch } from 'react-redux';
import getDeviceKindDependsOnViewPort from '@gc-npm/utils.common.get-device-kind-depends-on-viewport';
import {
  actions as modalActions,
} from '@gc-npm/reducers.modals-reducer';
import dynamic from 'next/dynamic';

export const SCX_PATH = 'https://{env}.cms.col.movistar.es/static/js/scx/scx.js';

const C2CModule = ({
  text, color, size, fontType, align, decoration, phone, campaign
}) => {
  const taggingInfoC2C = {
    componentName: 'simple-phone',
    componentVariation: 'all',
    componentContent: 'Te llamamos',
    componentProduct: '',
    eventType: 'click',
  };
  const dispatch = useDispatch();

  const openModal = () => {
    const device = getDeviceKindDependsOnViewPort();
    const MODAL_PROPS = {
      contentPosition:
        device !== 'MOBILE' ? 'center--center' : 'center--bottom',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'fadeInBottom',
      outSceneEffect: 'fadeOutBottom',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    const FormC2C = dynamic(() => import('@gc-npm/components.forms.form-c2c'));
    dispatch(
      modalActions.addModal({
        id: 'contratacion',
        type: 'MODAL',
        elementProps: { phone: phone, campaign: campaign },
        Element2Show: FormC2C,
        modalProps: MODAL_PROPS,
      }),
    );
  };

  return (
    <>
      <CustomLink
        onClick={openModal}
        taggingInfo={taggingInfoC2C}
        cyData="SimplePhone Text C2C"
      >
        <TextInfo
          text={text}
          color={color}
          size={size}
          fontType={fontType}
          align={align}
          decoration={decoration}
          cyData="SimplePhone Text C2C"
          className="C2C-modal-button"
        />
      </CustomLink>
      <style jsx>
        {`
          .container-C2C {
            display: flex;
            flex-flow: wrap;
            column-gap: 0.3rem;
            align-items: center;
            width: 100%;

            :global(.text) {
                overflow: hidden;
                white-space: nowrap;
                text-wrap: nowrap;
            }
          }
          .c2c-modal-link-separator {
              width: 100%;
              height: 0;
              margin-bottom: 1.5rem;
          }
        `}
      </style>
    </>
  );
}

export default C2CModule;
